import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import { faCircleCheck, faUserAlt, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import './UniModalUserEdit.scss';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { useUserStore } from "../../store/user";
import { CustomerDto, CustomerResponse, UsersResponse, getAllCustomers, getProfileToStr, updateUser } from "../../services/userService";
import UniModal from "../UniModal/UniModal";
import { useTranslation } from 'react-i18next';

const UniModalUserEdit = (props: any) => {
    const [selectedUser, setSelecteUser] = useState<any>({});
    const [showForm, setShowForm] = useState(false);
    const [showError, setShowError] = useState(false);
    const [showModalSuccess, setShowModalSuccess] = useState(false);
    const [showModalError, setShowModalError] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [users, setUsers] = useState<UsersResponse[]>();
    const [customers, setCustomers] = useState<any[]>();
    const [selectedCustomers, setSelectedCustomers] = useState<any>();
    const [selectedProfile, setSelectedProfile] = useState<any>();
    const [selectedActive, setSelectedActive] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);
    const { darkMode, selectedCustomer } = useUserStore();
    const { i18n, t } = useTranslation();

    const mockDataTable = {
        headers: [
            {
                property: 'name',
                name: t('user.labelName'),
            },
            {
                property: 'email',
                name: 'Email',
            },
            {
                property: 'active',
                name: t('user.labelActive')
            },
            {
                property: 'createdAt',
                name: t('user.labelCreatedAt'),
                date: true
            },
            {
                property: 'profile',
                name: t('user.labelProfile'),
                enum: true
            },
            {
                property: 'actions',
                name: t('user.labelActions')
            },
        ]
    };

    const hide = () => {
        setShowForm(false);
        props.onHide();
    }

    useEffect(() => {
        if ((props.show || !showForm) && props.userCustomer != undefined) {
            setLoading(true);
            setShowForm(true);
            console.log(props.userCustomer, 'props.userCustomer')
            setSelecteUser(props.userCustomer);
            setSelectedActive(props.userCustomer.active);
            setSelectedProfile(props.userCustomer.profile);
            getAllCustomers()
                .then(data => {
                    setCustomers(data.data?.customers.map(c => { return { value: c.id, label: `${c.issuer} ${c.searchTerm1 ? c.searchTerm1 : c.searchTerm2 ? c.searchTerm1 : c.issuerName}`, ...c } }));
                    setSelectedCustomers(props.userCustomer.customers.map((c: CustomerDto) => { return { value: c.customerId, label: `${c.issuer} ${c.searchTerm1 ? c.searchTerm1 : c.searchTerm2 ? c.searchTerm1 : c.issuerName}` } }));
                })
                .catch(err => console.log(err))
                .finally(() => setLoading(false))
        }
    }, [props.show, showForm]);

    const update = async (event: any) => {
        event.preventDefault();
        event.stopPropagation();

        const customersBody: CustomerResponse[] = selectedCustomers?.map((c: any) => {
            let customer = customers?.filter(cs => cs.id == c.value)?.[0];

            if (customer) {
                return {
                    customerId: customer.id,
                    issuer: customer.issuer,
                    customerName: customer.issuerName,
                    cpfCnpj: customer.cnpjCpf,
                    userId: selectedUser.userId,
                    country: customer.country ?? 'BR'
                }
            }
        });

        setLoading(true);
        const response = await updateUser(selectedUser.userId, Number(selectedProfile), selectedActive, customersBody);
        setLoading(false);

        if (!!response.success) {
            setShowModalSuccess(true);
            props.onHide();
        }
        else {
            setErrorMessage(response.error ? response.error : t('user.errorSave'));
            setShowModalError(true);
        }
    }

    const selectProfileOptions = [
        // { value: '4', label: 'Admin' },
        { value: '3', label: t('user.labelOperator') },
        // { value: '2', label: 'Operador Log.' },
        { value: '1', label: t('user.labelViewer') }
    ]
    const selectAdminOptions = [
        { value: '4', label: 'Admin' },
        // { value: '3', label: 'Operador' },
        // { value: '2', label: 'Operador Log.' },
        // { value: '1', label: 'Visualizador' }
    ]

    return (
        <>
            <Modal
                show={props.show}
                onHide={() => hide()}
                className={showForm ? 'modal-user modal-form-user' : 'modal-user'}
                contentClassName={darkMode ? 'dark-modal-content' : ''}
            >
                <Modal.Header closeButton>
                    <div className='header-body'>
                        <Modal.Title className='mt-3'>
                            {showForm ? t('user.labelEditUser') : t('user.labelUsers')}
                        </Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {
                        !showForm ? (
                            <table className='table-uni'>
                                <thead>
                                    <tr>
                                        {
                                            mockDataTable.headers.map(header => (
                                                <td key={header.name}>
                                                    {header.name}
                                                </td>
                                            ))
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        loading ? (
                                            <tr>...</tr>
                                        ) : (
                                            users?.map((user: UsersResponse | any) => (
                                                <tr key={user.name}>
                                                    {
                                                        mockDataTable.headers.map(header => {
                                                            if (header.property === 'actions') {
                                                                return (
                                                                    <td key={header.name} className='table-actions'>
                                                                        <div className='table-icon' onClick={() => {
                                                                            setShowForm(true);
                                                                            setShowError(false);
                                                                            setSelecteUser(user);
                                                                        }}>
                                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                                        </div>
                                                                    </td>
                                                                );
                                                            }

                                                            if (typeof (user?.[header.property]) == 'boolean') {
                                                                return (<td key={header.name}>{user?.[header.property] == true ? t('user.labelYes')  : t('user.labelNo') }</td>);
                                                            }

                                                            if (!!header.date) {
                                                                return (<td key={header.name}>{new Date(user?.[header.property]).toLocaleDateString() || ''}</td>);
                                                            }

                                                            if (!!header.enum) {
                                                                return (<td key={header.name}>{getProfileToStr(user?.[header.property])}</td>);
                                                            }

                                                            if (typeof (user?.[header.property]) == 'string') {
                                                                return (
                                                                    <td
                                                                        key={header.name}
                                                                        title={user?.[header.property]?.length > 12 ?
                                                                            user?.[header.property] ?? '' :
                                                                            ''}>
                                                                        {user?.[header.property]?.length > 14 ? user?.[header.property]?.slice(0, 13) + '...' : user?.[header.property] ?? ''}
                                                                    </td>
                                                                );
                                                            }

                                                            return (
                                                                <td key={header.name}>{user?.[header.property] ?? ''}</td>
                                                            );
                                                        })
                                                    }
                                                </tr>
                                            ))
                                        )
                                    }
                                </tbody>
                            </table>
                        ) : (
                            <Form onSubmit={update} className='form-user'>
                                <div className='card-user'>
                                    <FontAwesomeIcon icon={faUserAlt} />
                                    <p>{selectedUser.name} - {selectedUser.email}</p>
                                </div>
                                <div className='d-flex flex-column align-items-center justify-content-between form-user-content'>
                                    <div className='profile-inputs'>
                                        {showError && (<p className='p-error'>{t('user.labelNotRealized')}</p>)}
                                        <label className='label'>{t('user.labelUserActive')}</label>
                                        {loading ? (
                                            <tr>...</tr>
                                        ) :
                                            (

                                                <div>
                                                    <Form.Check
                                                        inline
                                                        label={t('user.labelYes')}
                                                        name='active'
                                                        value='0'
                                                        type='radio'
                                                        defaultChecked={selectedUser.active}
                                                        onChange={() => setSelectedActive(true)}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label={t('user.labelNo')}
                                                        name='active'
                                                        value='1'
                                                        type='radio'
                                                        defaultChecked={!selectedUser.active}
                                                        onChange={() => setSelectedActive(false)}
                                                    />
                                                </div>
                                            )}

                                    </div>
                                    <div className='d-flex justify-content-between w-100'>
                                        <div className='profile-inputs'>
                                            <label className='label'>{t('user.labelProfile')}</label>
                                            <div>
                                                {loading ? (<Spinner style={{ color: '#027948', width: 25, height: 25 }} />) : (
                                                    <Select
                                                        placeholder={t('user.labelSelect')}
                                                        defaultValue={selectedUser.profile == 4 ? selectAdminOptions : selectProfileOptions.filter(p => p.value === selectedProfile.toString())?.[0] ?? {}}
                                                        onChange={(value) => setSelectedProfile(value?.value)}
                                                        isDisabled={selectedUser.profile == 4}
                                                        options={selectProfileOptions}
                                                        className='select-customers'
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className='customer-input'>
                                            <label className='label'>{t('user.labelClient')}</label>
                                            {
                                                loading ? (<Spinner style={{ color: '#027948', width: 25, height: 25 }} />) : (
                                                    <Select
                                                        placeholder={t('user.labelSelect')}
                                                        onChange={(newValue) => setSelectedCustomers(newValue)}
                                                        defaultValue={selectedCustomers}
                                                        options={customers}
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        className='select-customers'
                                                    />
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className='buttons-user-form d-flex'>
                                    <Button
                                        variant='outline'
                                        disabled={loading}
                                        onClick={() => {
                                            // setSelecteUser({});
                                            hide();
                                        }
                                        }>
                                        {t('user.labelBack')}
                                    </Button>
                                    <Button type='submit' disabled={loading}>{loading ? <Spinner style={{ width: 20, height: 20 }} /> : t('user.labelSave')}</Button>
                                </div>
                            </Form>
                        )
                    }
                </Modal.Body>
            </Modal>
            <UniModal
                icon={faCircleCheck}
                title={t('user.modifierSucess')}
                message=''
                show={showModalSuccess}
                onHide={() => {
                    setShowModalSuccess(false);
                }}
                isFontAwsome
                iconWidth={100}
                iconHeight={110}
            >
                <div className='modal-body-resume'>
                    <p></p>
                    <Button onClick={() => setShowModalSuccess(false)}>Ok!</Button>
                </div>
            </UniModal>
            <UniModal
                icon={faXmarkCircle}
                title={t('user.modifierError')}
                message=''
                iconColor='#EA2027'
                show={showModalError}
                onHide={() => {
                    setShowModalError(false);
                }}
                isFontAwsome
                iconWidth={100}
                iconHeight={110}
            >
                <div className='modal-body-resume'>
                    <p>{errorMessage}</p>
                    <Button onClick={() => setShowModalError(false)}>Ok</Button>
                </div>
            </UniModal>
        </>
    );
}

export default UniModalUserEdit;